import { useExperimentTreatment } from '@ms/yammer-experiments-context';
import { useIsCurrentNetworkInMto } from '@ms/yammer-libs-app-context';
import { isTeamsBrandedExperience } from '@ms/yammer-web-support/dist/teamsBrandedExp';

export const useIsEngageIASimplificationPhase1WithoutReporting = (): boolean => {
  const isEngageIASimplificationPhase1 = useExperimentTreatment('EngageIASimplificationPhase1');
  const isCurrentNetworkInMto = useIsCurrentNetworkInMto();

  return !isTeamsBrandedExperience() && !isCurrentNetworkInMto && isEngageIASimplificationPhase1;
};
